import jwt from 'jsonwebtoken';

import Api from './api';

import { AuthToken } from 'src/utils/token';
import { constants } from 'src/utils/settings';
import { Paths } from 'src/utils/constants';

export async function hasActiveSession(): Promise<boolean> {
  try {
    const response: any = await Api.getRequest(Paths.auth.getAuthData, {
      baseURL: constants.api.authUrl,
      withCredentials: true,
    });
    const data = response?.data;
    if (data?.validatedResult?.status !== true || !data?.token) return false;
    const decoded = jwt.decode(data.token) as AuthToken | null;
    return !decoded?.exp || Date.now() < decoded.exp * 1000;
  } catch {
    return false;
  }
}

export function getAuthToken(data = {}) {
  return Api.postRequest(Paths.auth.authorization, data, {
    baseURL: constants.api.authUrl,
    withCredentials: true,
  });
}

export function getAuthData(){
  return Api.getRequestWithAuthentication(Paths.auth.getAuthData, {
    baseURL: constants.api.authUrl,
    withCredentials: true,
  });
}
export function logoutSession(data = {}) {
  return Api.postRequestWithAuthentication(Paths.auth.logout, data, {
    baseURL: constants.api.authUrl,
  });
}

export function getRefreshToken(data = {}) {
  return Api.postRequestWithAuthentication(Paths.auth.refreshToken, data, {
    baseURL: constants.api.authUrl,
  });
}

export function validateEmail(data: any = {}) {
  return Api.getRequest(`${Paths.member.validateEmail}?id=${data.accountId}`, {
    baseURL: constants.api.userUrl,
  });
}
